import { toQuery } from '@debbie/common/dist/util/index.js';
import { collectionEngineV1 } from '../apis.js';
const reqV1 = collectionEngineV1('/properties');
export const historical = (ref, refId, handle) => reqV1('GET', `/${ref}/${refId}/${handle}/history`);
export const get = (p, casualConsistency) => reqV1('GET', `/${p.ref}/${p.refId}?${toQuery({
    casualConsistency: casualConsistency ? true : undefined,
})}`);
export const getMultiple = (p, casualConsistency) => reqV1('POST', `/multiple?${toQuery({
    casualConsistency: casualConsistency ? true : undefined,
})}`, {
    body: {
        refIds: p.refIds,
        ref: p.ref,
    },
});
export const getTypes = () => reqV1('GET', '/types');
export const setOrdering = (ordering) => reqV1('POST', '/types/ordering', {
    body: ordering,
});
export const createType = (data) => reqV1('POST', '/types', {
    body: {
        ref: data.ref,
        scopes: data.scopes,
        data: data.data,
        description: data.description,
        handle: data.handle,
        label: data.label,
        permissionLevel: data.permissionLevel,
        permissionLevelEdit: data.permissionLevelEdit,
        required: data.required,
        type: data.type,
    },
});
export const patchType = (propertyTypeId, patch) => reqV1('PATCH', `/types/${propertyTypeId}`, {
    body: patch,
});
export const update = (data) => reqV1('PATCH', `/${data.ref}/${data.refId}/${data.handle}`, {
    body: {
        data: data.data,
        type: data.type,
    },
});
export const delType = (propertyTypeId) => reqV1('DELETE', `/types/${propertyTypeId}`);
//# sourceMappingURL=properties.js.map